<mat-toolbar class="rentalsbg">
    <div>
        <a mat-icon-button (click)="clickBack()">
            <mat-icon>keyboard_arrow_left</mat-icon>
        </a>
        <span>{{db.itemsFiltered.length}} Rentals</span>
    </div>
    <div class="form">
        <button mat-icon-button *ngIf="db.itemsPageConfig.map" (click)="toggleMap()">
            <mat-icon>{{GLOBAL.ICONS.LIST}}</mat-icon>
        </button>
        <button mat-icon-button *ngIf="!db.itemsPageConfig.map" (click)="toggleMap()">
            <mat-icon>{{GLOBAL.ICONS.ADDRESS}}</mat-icon>
        </button>
        <form [formGroup]="searchForm" novalidate>
            <mat-form-field appearance="fill">
                <mat-label>Search</mat-label>
                <input matInput formControlName="search">
                <mat-icon matSuffix *ngIf="searchForm.get('search').value" (click)="clearSearch()">close</mat-icon>
                <mat-icon matSuffix *ngIf="!searchForm.get('search').value">search</mat-icon>
            </mat-form-field>
        </form>
    </div>
    <profile></profile>
</mat-toolbar>
<div class="toolbartop"></div>

<div class="main-container-flex split">
    <mat-spinner *ngIf="!db.loaded" [strokeWidth]="5"></mat-spinner>
    <app-table class="main" tableKey="rental"  [offset]="db.itemsPageConfig.scrollIndex" [ngClass]="{hide: db.itemsPageConfig.map}"
        [item]="item" [items]="db.itemsFilteredOrdered" (sortChange)="sortChange($event)" (clickFn)="goItem($event)"
        (overFn)="previewItem($event)" (scrollFn)="scrollItems($event)"></app-table>
    <app-gmap class="main" *ngIf="db.itemsPageConfig.map" [markers]="db.itemsFiltered" (clickFn)="goItem($event)"
        [params]="paramInit" (filter)="mapFilter($event)" (overFn)="previewItem($event)">
    </app-gmap>
    <div class="side">
        <mat-tab-group [(selectedIndex)]="db.itemsPageConfig.sideTab">

            <!-- FILTERS -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="example-tab-icon">{{GLOBAL.ICONS.PARAM}}</mat-icon>
                </ng-template>

                <form [formGroup]="sortServerForm" novalidate>
                    <ng-container formGroupName="filters">
                        <mat-form-field appearance="fill"
                            *ngIf="!select.active && setting.getParamsSelect('userAgencies') && setting.getParamsSelect('userAgencies').length > 1 && db.auth.isOneOfRoles(['admin', 'director', 'assistant', 'marketing'])">
                            <mat-label>Agency</mat-label>
                            <mat-select formControlName="rentalAgency">
                                <mat-option *ngFor="let param of 'userAgencies' | params" [value]="param.id">
                                    {{param.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field appearance="fill" *ngIf="select.active">
                            <mat-label>Agency</mat-label>
                            <mat-select formControlName="rentalAgency">
                                <mat-option *ngFor="let param of 'agencies' | params" [value]="param.id">
                                    {{param.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>

                        <mat-form-field appearance="fill"
                            *ngIf="!select.active && db.auth.isOneOfRoles(['admin', 'director', 'assistant', 'marketing'])">
                            <mat-label>Realtor</mat-label>
                            <mat-select formControlName="rentalRealtor">
                                <mat-option value="">All Agents</mat-option>
                                <mat-option
                                    *ngFor="let param of setting.realtorsAgency[sortServerForm.get('filters.rentalAgency').value] || []"
                                    [value]="param.id">
                                    {{param.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </ng-container>

                    <ng-container formGroupName="multiFilters">
                        <mat-form-field appearance="fill">
                            <mat-label>Rental Status</mat-label>
                            <mat-select formControlName="rentalStatus" [multiple]="true">
                                <mat-option *ngFor="let param of 'rentalStatus' | params" [value]="param.id">
                                    {{param.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </ng-container>
                </form>
            </mat-tab>

            <!-- PREVIEW -->
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class="example-tab-icon">{{GLOBAL.ICONS.VIEW}}</mat-icon>
                </ng-template>
                <app-unit-card [values]="preview"></app-unit-card>
            </mat-tab>

        </mat-tab-group>
    </div>
</div>

<button mat-fab class="bottom-right pfixed" (click)="addItem()">
    <mat-icon matListIcon>add</mat-icon>
</button>
